module.exports = __webpack_public_path__ + "img/protfolio_bg.3693d65a.jpg";